import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { CampaignIcon } from 'components/Atoms/Icon';
import { USER_ROLES } from 'constants/common';

const CampaignManagement = lazy(() => import('modules/campaign/Campaign'));

export const campaignRoutes = [
  {
    path: routePath.CAMPAIGN_MANAGEMENT,
    component: CampaignManagement,
    exact: true,
    name: routeName.CAMPAIGN_MANAGEMENT,
    showMenu: true,
    icon: CampaignIcon,
    roles: [USER_ROLES.ADMIN],
    breadcrumbs: [{ name: routeName.CAMPAIGN_MANAGEMENT }],
  },
];
